/* eslint-disable max-len */
// THIS FILE IS USED TO GENERATE CHUNKS PER PAGE
// SO THAT SPA'S CAN LOAD THE NECESSARY CHUNKS PER PAGE
/* eslint-disable no-nested-ternary */
import { generateAsyncRoute } from '@thd-olt-component-react/router';

const ssr = typeof window === 'undefined';

export const getRoutes = (currentRouteName, currentRouteComponent) => ({
  shared: {
    name: 'shared',
    componentName: 'SharedContainer',
    chunk: () => import(
      /* webpackChunkName: "shared" */
      './pages/shared/SharedContainer'
    ),
    get component() {
      return ssr
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/shared/SharedContainer.js')).SharedContainer
        : currentRouteName === 'shared'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.SharedContainer })));
    },
    path: '/:context?/list/view/details/shared/:listId',
    channel: 'desktop'
  },
  sharedMobile: {
    name: 'shared-mobile',
    componentName: 'SharedMobileContainer',
    chunk: () => import(
      /* webpackChunkName: "shared" */
      './pages/shared/SharedMobileContainer'
    ),
    get component() {
      return ssr
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/shared/SharedMobileContainer.js')).SharedMobileContainer
        : currentRouteName === 'shared-mobile'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.SharedMobileContainer })));
    },
    path: '/:context?/list/view/details/shared/:listId',
    channel: 'mobile'
  },
  list: {
    name: 'list',
    componentName: 'ListContainer',
    chunk: () => import(
      /* webpackChunkName: "list" */
      './pages/list/ListContainer'
    ),
    get component() {
      return ssr
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/list/ListContainer.js')).ListContainer
        : currentRouteName === 'list'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.ListContainer })));
    },
    path: '/:context?/list/view/details/:listId',
    channel: 'desktop'
  },
  listMobile: {
    name: 'list-mobile',
    componentName: 'ListMobileContainer',
    chunk: () => import(
      /* webpackChunkName: "list-mobile" */
      './pages/list/ListMobileContainer'
    ),
    get component() {
      return ssr
        // eslint-disable-next-line max-len
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/list/ListMobileContainer.js')).ListMobileContainer
        : currentRouteName === 'list-mobile'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk()
            .then((pageModule) => ({ default: pageModule.ListMobileContainer })));
    },
    path: '/:context?/list/view/details/:listId',
    channel: 'mobile'
  },
  summary: {
    name: 'summary',
    componentName: 'SummaryContainer',
    chunk: () => import(
      /* webpackChunkName: "summary" */
      './pages/summary/SummaryContainer'
    ),
    get component() {
      return ssr
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/summary/SummaryContainer.js')).SummaryContainer
        : currentRouteName === 'summary'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.SummaryContainer })));
    },
    path: '/:context?/list/view/summary',
    channel: 'desktop'
  },
  summaryMobile: {
    name: 'summary-mobile',
    componentName: 'SummaryMobileContainer',
    chunk: () => import(
      /* webpackChunkName: "summary-mobile" */
      './pages/summary/SummaryMobileContainer'
    ),
    get component() {
      return ssr
        // eslint-disable-next-line max-len
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/summary/SummaryMobileContainer.js')).SummaryMobileContainer
        : currentRouteName === 'summary-mobile'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk()
            .then((pageModule) => ({ default: pageModule.SummaryMobileContainer })));
    },
    path: '/:context?/list/view/summary',
    channel: 'mobile'
  },
  home: {
    name: 'home',
    componentName: 'Home',
    chunk: () => import(
      /* webpackChunkName: "home" */
      './pages/Home'
    ),
    get component() {
      return ssr
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/Home.js')).Home
        : currentRouteName === 'home'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.Home })));
    },
    path: '/:context?/',
    channel: null
  }

});

export const getRouteChunk = async (currentRouteName) => {
  const routes = getRoutes();
  const routeKey = Object.keys(routes).filter((key) => routes[key].name === currentRouteName)[0];
  const route = routes[routeKey];
  const componentModule = await route.chunk();
  return componentModule[route.componentName];
};
